import { configConstants } from '../constants';
import axios from 'axios';

import { history, setHeaders } from 'helpers';

export const extensionServices = {
   oauthInitiate,
   getMagentoToken,
   generateApiKey
};

function oauthInitiate(merchantId) {
    //let tmp = axios.get(configConstants.API_BACKEND_CRM + `/magento/oauth-initiate`, {
    //let tmp = axios.get(`http://localhost:3001/api/v1/magento/oauth-initiate`, {
      
    let tmp = axios.get(configConstants.API_BACKEND_CRM + `/magento/oauth-initiate/${merchantId}`, {  
       headers: setHeaders({ 'Charset': 'utf-8' })
    })
       .then(response => {
          if (response.data.statusCode.toString() === "200") {
             return {
                status: true,
                data: response.data,
                message: response.message
             };
          } else if (response.data.message === "UNAUTHORIZE") {
             history.push('/auth/login')
             return { status: false, data: {}, message: response.data.message, unAlert: true };
          } else {
             return {
                status: false,
                data: {},
                message: response.data.message
             };
          }
       })
       .catch(e => {
          return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
       });
 
    return tmp;
}

function getMagentoToken(merchantId) {
    
 
     //let tmp = axios.get(configConstants.API_BACKEND_CRM + `/magento/oauth-initiate`, {
     //let tmp = axios.get(`http://localhost:3001/api/v1/magento/get-token/${merchantId}`, {
     let tmp = axios.get(configConstants.API_BACKEND_CRM + `/magento/get-token/${merchantId}`, {    
        headers: setHeaders({ 'Charset': 'utf-8' })
     })
        .then(response => {
           if (response.data.statusCode.toString() === "200") {
              return {
                 status: true,
                 data: response.data,
                 message: response.message
              };
           } else if (response.data.message === "UNAUTHORIZE") {
              history.push('/auth/login')
              return { status: false, data: {}, message: response.data.message, unAlert: true };
           } else {
              return {
                  status: true,
                  data: {
                     data: {
                        magentos: {
                           magentoID: "",
                           magentoPermanentToken: "",
                           magentoPermanentSecret: ""
                        }
                     }
                  },
                  message: response.data.message
              };
           }
        })
        .catch(e => {
         //   console.log('e:',e)
           return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
        });
  
     return tmp;
 }


function generateApiKey(merchantId, reqParams) {
   let tmp = axios.post(configConstants.API_BACKEND_CRM + `/woo-commerce/oauth-initiate/${merchantId}`, reqParams, {  
      headers: setHeaders({ 'Charset': 'utf-8' })
   })
   .then(response => {
      if (response.data.statusCode.toString() === "200") {
         return {
            status: true,
            data: response.data,
            message: response.message
         };
      } else if (response.data.message === "UNAUTHORIZE") {
         history.push('/auth/login')
         return { status: false, data: {}, message: response.data.message, unAlert: true };
      } else {
         return {
            status: false,
            data: {},
            message: response.data.message
         };
      }
   })
   .catch(e => {
      return { status: false, data: {}, message: "SOMETHING_WENT_WRONG" };
   });

   return tmp;
}